export enum Agroupation {
  HOUR="HOUR",
  DAY="DAY",
  TOTAL="TOTAL"
}